import { useState } from "react";

type ResendDialogProps = {

    /**
     * Callback method that gets executed when dialog closes successful.
     */
    onConfirm: (recipient: string) => void;
}

const ResendDialog = ({ onConfirm }: ResendDialogProps) => {

    const [recipient, setRecipient] = useState<string>("");
    const [show, setShow] = useState<boolean>(false);

    function handleConfirm(): void {

        setShow(false);
        onConfirm(recipient);
    }

    return (
        <>
            <button className="btn btn-warning w-100" onClick={e => setShow(true)}>
                <i className="bi bi-envelope"></i> Resend Claim
            </button>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>Please enter a recipient address</h5>
                            <button type="button" className="btn-close" onClick={e => setShow(false)}></button>
                        </div>

                        <div className="modal-body">
                            <div className="row">

                                <div className="form-group col-12">
                                    <label htmlFor="modalEmail" className="fw-bold">Recipient Address</label>
                                    <input type="email" className="form-control" id="modalEmail" onChange={e => setRecipient(e.target.value)}></input>
                                </div>

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-success" type="button" onClick={handleConfirm}>Resend</button>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default ResendDialog;